(() => {
  const hostSelector = 'shopify-forms-embed#app-embed-container-1128856';
  const rootSelector = '#app-embed[data-form-root="true"]';
  const collisionAttribute = 'data-tina-gift-collision';
  const mobile = window.matchMedia('(max-width: 55rem)');
  let host;
  let shadow;
  let guardedRoot;
  let frame = 0;

  const mobileStyles = `
    @media (max-width: 55rem) {
      #app-embed[data-form-root="true"] [role="button"][aria-label="Close modal"] {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        min-width: 44px !important;
        min-height: 44px !important;
      }
      #app-embed[data-form-root="true"] input:not([type="checkbox"]):not([type="radio"]),
      #app-embed[data-form-root="true"] select,
      #app-embed[data-form-root="true"] textarea {
        font-size: 16px !important;
      }
      #app-embed[data-tina-gift-collision],
      #app-embed[data-tina-gift-collision] * {
        visibility: hidden !important;
        pointer-events: none !important;
      }
    }
  `;

  function schedule() {
    if (!frame) frame = window.requestAnimationFrame(update);
  }

  const shadowObserver = new MutationObserver(schedule);

  function connect() {
    const nextHost = document.querySelector(hostSelector);
    const nextShadow = nextHost?.shadowRoot;
    if (host !== nextHost || shadow !== nextShadow) {
      guardedRoot?.removeAttribute(collisionAttribute);
      guardedRoot = null;
      shadowObserver.disconnect();
      host = nextHost;
      shadow = nextShadow;
      if (shadow) {
        shadowObserver.observe(shadow, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['data-current-step', 'data-testid', 'data-form-root', 'role', 'id'],
        });
      }
    }
    if (!shadow) return null;
    if (!shadow.querySelector('style[data-tina-gift-guard]')) {
      const style = document.createElement('style');
      style.setAttribute('data-tina-gift-guard', '');
      style.textContent = mobileStyles;
      shadow.append(style);
    }
    return shadow.querySelector(rootSelector);
  }

  function visibleControl(element) {
    if (element.matches(':disabled') || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    if (window.getComputedStyle(element).pointerEvents === 'none') return false;
    for (let current = element; current; current = current.parentElement) {
      const style = window.getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || style.opacity === '0') return false;
    }
    return true;
  }

  function update() {
    frame = 0;
    const root = connect();
    if (guardedRoot !== root) guardedRoot?.removeAttribute(collisionAttribute);
    guardedRoot = root;
    if (!root) return;
    const teaser = root.querySelector('[data-testid="form-teaser"]');
    if (!mobile.matches || !teaser || root.dataset.currentStep === 'form' || root.matches('[role="dialog"]') || root.querySelector('[role="dialog"]')) {
      root.removeAttribute(collisionAttribute);
      return;
    }

    const teaserRect = teaser.getBoundingClientRect();
    let collision = false;
    if (teaserRect.width > 0 && teaserRect.height > 0) {
      const controls = document.querySelectorAll('a[href], button, input:not([type="hidden"]), select, textarea, summary');
      for (const control of controls) {
        const rect = control.getBoundingClientRect();
        if (rect.width > 0 && rect.height > 0 && rect.right > 0 && rect.bottom > 0 && rect.left < window.innerWidth && rect.top < window.innerHeight &&
          teaserRect.left < rect.right && teaserRect.right > rect.left && teaserRect.top < rect.bottom && teaserRect.bottom > rect.top && visibleControl(control)) {
          collision = true;
          break;
        }
      }
    }
    root.toggleAttribute(collisionAttribute, collision);
  }

  const hostObserver = new MutationObserver(() => {
    if (!host?.isConnected || host.shadowRoot !== shadow) schedule();
  });
  hostObserver.observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule, { once: true });
  mobile.addEventListener('change', schedule);
  window.customElements?.whenDefined('shopify-forms-embed').then(schedule);
  schedule();
})();
